import { type Html, html, View } from 'rune-ts';
import klass from './Business.module.scss';
import { font, staticFont } from '@services/MarppleShop/shared/typography';
import { map, pipe, toArray } from '@fxts/core';
import { UtilImageS } from '@modules/Util/Image/S/Function/module/UtilImageS';
import { getResizedUrl } from '@services/MarppleShop/shared/util/image.ts';

const upper_img_urls = [
  '//s3.marpple.co/files/u_4648126/2025/6/original/e0f78782209276c6bf7dce6e398c928343a338f41.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/224edb763a6e2f4862110e2fd04d1bcd0345d93d10.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/1aaceded2e9a82616552d80770a22eb9b50458439.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/dc90f7e209b8271be4dc7f834ae76bbafd0b3da38.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/b468c19cdc3d2b294fafea781701d2bedfba0feb7.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/3544612607f486895e3fecad769302cd45fc7cbc6.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/868c195d9e731e09cb2e057ca498652b2aa7877b5.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/94f1103373295858ebdd16daa86644513a4a2f074.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/99091e2b2beb77e9feef03f7430af873d1454f9f3.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/f4ab1da0a9ade241b86504f3e0954fcae21cd6b72.png',
];

const lower_img_urls = [
  '//s3.marpple.co/files/u_4648126/2025/6/original/260b3e3b976517c5baa0cd4e7d7b447eeac63a551.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/f92dc3a5af9b526bfd941fb06a417e34062e064a11.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/9004f99aff63c72af4a3b4332bc949362f5fdd3410.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/0f715ffabfdda59b839a4f6fda3398e9cd0f87df9.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/ecf72b1a6a15bc9b032b8128c2729a3a42d95fc68.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/85bcf7864ee406cb345390285069feb2c43b4c617.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/84219608269bed7d50f780b7df56df135e0893b56.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/333e500f7447f605c0e55b90b8430a4862463c9e5.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/1f9d81b323e3c8b83e9ff1d8e91fe85e18f3685a4.png',
  '//s3.marpple.co/files/u_4648126/2025/6/original/4e58074d50268a69d52b1d84bb5e7b3ee84529583.png',
];

export class BusinessSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    return html`
      <section class="${klass.container}">
        <div class="${klass.content}">
          <div class="${staticFont('bebas_20_bold')}">CHAPTER 3.</div>
          <div class="${font('48_bold', '28_bold')}">
            마플샵은 많은 크리에이터와 <br />
            기업들과 함께 하고 있어요
          </div>
        </div>
        <div class="${klass.business_list}">
          <div class="${klass.marquee_wrapper} ${klass.top}">
            <div class="${klass.marquee_background}">
              ${pipe(
                upper_img_urls,
                map((url) => UtilImageS.getResizedUrl({ url, quality: 85, width: 1920 * 2, format: 'webp' })),
                map(
                  (src) =>
                    html`<div class="${klass.marquee_item}">
                      <img src="${src}" alt="marquee-product" />
                    </div>`,
                ),
                toArray,
              )}
            </div>
            <div class="${klass.marquee_background}" aria-hidden="true">
              ${pipe(
                lower_img_urls,
                map((url) => UtilImageS.getResizedUrl({ url, quality: 85, width: 1920 * 2, format: 'webp' })),
                map(
                  (src) =>
                    html`<div class="${klass.marquee_item}">
                      <img src="${src}" alt="marquee-product" />
                    </div>`,
                ),
                toArray,
              )}
            </div>
          </div>
          <div class="${klass.marquee_wrapper} ${klass.bottom}">
            <div class="${klass.marquee_background}">
              ${pipe(
                upper_img_urls,
                map((url) => UtilImageS.getResizedUrl({ url, quality: 85, width: 1920 * 2, format: 'webp' })),
                map(
                  (src) =>
                    html`<div class="${klass.marquee_item}">
                      <img src="${src}" alt="marquee-product" />
                    </div>`,
                ),
                toArray,
              )}
            </div>
            <div class="${klass.marquee_background}" aria-hidden="true">
              ${pipe(
                lower_img_urls,
                map((url) => UtilImageS.getResizedUrl({ url, quality: 85, width: 1920 * 2, format: 'webp' })),
                map(
                  (src) =>
                    html`<div class="${klass.marquee_item}">
                      <img src="${src}" alt="marquee-product" />
                    </div>`,
                ),
                toArray,
              )}
            </div>
          </div>
        </div>
        <img
          src="${getResizedUrl({
            url: '//s3.marpple.co/files/u_4648126/2025/6/original/b70ae8e91ec7a8776405763219a7d476e9b0895e1.png',
            width: 544 * 2,
            quality: 85,
            format: 'webp',
          })}"
          class="${klass.maluv}"
          alt="character icon"
        />
      </section>
    `;
  }
}
